/**
 * @generated SignedSource<<24dcd09f79cbf9eef4253daabf629d4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PrivateNotesPanelCreatePrivateNoteMutation$variables = {
  noteId?: string | null;
  streamId: string;
};
export type PrivateNotesPanelCreatePrivateNoteMutation$data = {
  readonly createPrivateNote: {
    readonly privateNote: {
      readonly id: string;
      readonly linkedNote: {
        readonly createdAt: string | null;
        readonly eventStart: string | null;
        readonly url: string | null;
      } | null;
      readonly note: {
        readonly attachments: ReadonlyArray<{
          readonly dimensions: {
            readonly height: number;
            readonly width: number;
          } | null;
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"AttachmentPreviewAttachment">;
        }>;
        readonly collapsedBlockKeys: ReadonlyArray<string>;
        readonly id: string;
        readonly rawDraftJson: any;
        readonly updatedAt: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"AttachmentsRelay_note">;
      };
      readonly title: string | null;
      readonly updatedAt: string | null;
    };
    readonly stream: {
      readonly privateNotes: ReadonlyArray<{
        readonly id: string;
        readonly linkedNote: {
          readonly createdAt: string | null;
          readonly eventStart: string | null;
          readonly id: string;
          readonly url: string | null;
        } | null;
        readonly title: string | null;
      }>;
    };
  } | null;
};
export type PrivateNotesPanelCreatePrivateNoteMutation = {
  response: PrivateNotesPanelCreatePrivateNoteMutation$data;
  variables: PrivateNotesPanelCreatePrivateNoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  },
  {
    "kind": "Variable",
    "name": "streamId",
    "variableName": "streamId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collapsedBlockKeys",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawDraftJson",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filename",
  "storageKey": null
},
v11 = {
  "alias": "directUrl",
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageDimensions",
  "kind": "LinkedField",
  "name": "dimensions",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filetype",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventStart",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "PrivateNote",
  "kind": "LinkedField",
  "name": "privateNotes",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "linkedNote",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v15/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PrivateNotesPanelCreatePrivateNoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreatePrivateNote",
        "kind": "LinkedField",
        "name": "createPrivateNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrivateNote",
            "kind": "LinkedField",
            "name": "privateNote",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v5/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AttachmentsRelay_note"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attachment",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageDimensions",
                        "kind": "LinkedField",
                        "name": "dimensions",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "AttachmentPreviewAttachment",
                        "selections": [
                          (v3/*: any*/),
                          (v10/*: any*/),
                          (v5/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/)
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "linkedNote",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PrivateNotesPanelCreatePrivateNoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreatePrivateNote",
        "kind": "LinkedField",
        "name": "createPrivateNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrivateNote",
            "kind": "LinkedField",
            "name": "privateNote",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attachment",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v10/*: any*/),
                      (v5/*: any*/),
                      (v15/*: any*/),
                      (v12/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "image",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "linkedNote",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "729250b420374f3e557bfd5bbea101fa",
    "id": null,
    "metadata": {},
    "name": "PrivateNotesPanelCreatePrivateNoteMutation",
    "operationKind": "mutation",
    "text": "mutation PrivateNotesPanelCreatePrivateNoteMutation(\n  $streamId: ID!\n  $noteId: ID\n) {\n  createPrivateNote(streamId: $streamId, noteId: $noteId) {\n    privateNote {\n      id\n      title\n      updatedAt\n      note {\n        id\n        collapsedBlockKeys\n        rawDraftJson\n        updatedAt\n        ...AttachmentsRelay_note\n        attachments {\n          id\n          dimensions {\n            height\n            width\n          }\n          ...AttachmentPreviewAttachment\n        }\n      }\n      linkedNote {\n        url\n        eventStart\n        createdAt\n        id\n      }\n    }\n    stream {\n      privateNotes {\n        id\n        title\n        linkedNote {\n          id\n          eventStart\n          createdAt\n          url\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment AttachmentPreviewAttachment on Attachment {\n  id\n  filename\n  updatedAt\n  directUrl: url\n  size\n  dimensions {\n    width\n    height\n  }\n  filetype\n}\n\nfragment AttachmentsRelay_note on Note {\n  id\n  attachments {\n    id\n    filename\n    updatedAt\n    url\n    size\n    filetype\n    creator {\n      id\n      image\n      fullName\n    }\n    dimensions {\n      width\n      height\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "94b85ae5e5d6c54221eedef42be3a8cd";

export default node;
